import React from 'react'
import { Layout } from './Layout'
import { LoadClinic } from '../../dataProviders/LoadClinic'
import { useRouteParam } from '../../browser/useRouteParam'

export const YourClinic: React.FC = () => {
  const id = useRouteParam('id')
  return <LoadClinic id={id} render={clinic => <Layout clinic={clinic[0]} />} />
}
